export default __webpack_public_path__ + "static/11_25-a5aab5d36b05d6739ac79536c11b691c.png";